// import Sliders from "./sliders";
import { Helmet, HelmetData } from "react-helmet-async";
import { Hero } from "./home/hero";
import PoweringAI from "./home/powering-ai";
import WhyChooseUsHome from "./home/why-choose-us";
import OurProduct from "./home/our-product";
import OurServices from "./home/our-services";
import { NewFooter } from "./newFooter";
import BookConsultation from "./book-a-consultation";
import { useRef } from "react";
import useIntersectionObserver from "../utils/useIntersectionObserver";

const helmetData = new HelmetData({});

export default function Main() {
  const targetRef = useRef(null);

  useIntersectionObserver({ targetRef });

  return (
    <>
      <Helmet helmetData={helmetData}>
        <title>Analytics Intelligence Africa | Enterprise AI &amp; Analytics Solutions Across Africa</title>
        <link rel="canonical" href="https://africa.analyticsintelligence.com/" />
        <meta
          name="description"
          content="Analytics Intelligence Africa delivers enterprise AI, data analytics, local language LLMs, and AI infrastructure for banking, fintech, and enterprise organisations across Nigeria, Ghana, Kenya, South Africa, Rwanda, and the African continent."
        />
        <meta
          name="keywords"
          content="Analytics Intelligence Africa, Analytics Intelligence, artificial intelligence Africa, enterprise AI Africa, data analytics Africa, AI for banking Africa, fintech AI Africa, AI company in Africa, AI company in Nigeria, AI company in Ghana, AI company in Kenya, analytics firm Africa, machine learning Africa, AI infrastructure Africa, local language LLMs Africa, African language AI, data annotation Africa, model evaluation Africa, AI data services Africa, predictive analytics Africa, business intelligence Africa, AI for financial services Africa, enterprise analytics Africa, AI startup Africa, AI company South Africa, data analytics Nigeria, AI Ghana, AI Kenya"
        />
        <meta property="og:title" content="Analytics Intelligence Africa | Enterprise AI & Analytics Solutions Across Africa" />
        <meta property="og:description" content="Enterprise AI, data analytics, local language LLMs, and AI infrastructure for banking, fintech, and enterprise organisations across Africa." />
        <meta property="og:url" content="https://africa.analyticsintelligence.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://africa.analyticsintelligence.com/favicon.png" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Analytics Intelligence Africa | Enterprise AI & Analytics Solutions Across Africa" />
        <meta name="twitter:description" content="Enterprise AI, data analytics, local language LLMs, and AI infrastructure for banking, fintech, and enterprise organisations across Africa." />
        <meta name="twitter:image" content="https://africa.analyticsintelligence.com/favicon.png" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "name": "Analytics Intelligence Africa",
                "alternateName": ["Analytics Intelligence", "AI Africa"],
                "url": "https://africa.analyticsintelligence.com",
                "logo": "https://africa.analyticsintelligence.com/favicon.png",
                "description": "Analytics Intelligence Africa is an enterprise AI and analytics company delivering AI infrastructure, local language LLMs, data annotation, model evaluation, and AI solutions for banking, fintech, and enterprise organisations across Africa.",
                "areaServed": ["Nigeria", "Ghana", "Kenya", "South Africa", "Rwanda", "Uganda", "Africa"],
                "knowsAbout": ["AI for Banking Africa", "Local Language LLMs", "Enterprise Analytics Africa", "Data Annotation Africa", "Model Evaluation Africa", "AI Infrastructure Africa", "Fintech AI Africa", "Predictive Analytics Africa", "African Language AI"]
              },
              {
                "@type": "WebSite",
                "url": "https://africa.analyticsintelligence.com",
                "name": "Analytics Intelligence Africa",
                "description": "Enterprise AI and analytics solutions for Africa — Analytics Intelligence Africa.",
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": "https://africa.analyticsintelligence.com/blog?search={query}",
                  "query-input": "required name=query"
                }
              }
            ]
          }
        `}</script>
      </Helmet>
      <main>
        <Hero observedRef={targetRef} />
        <PoweringAI />
        <WhyChooseUsHome />
        <OurProduct />
        <OurServices />
        <NewFooter>
          <BookConsultation
            title="Let’s help you annotate and label data that AI can use"
            text="We fine-tune models, streamline data, and scale your AI stack
          effortlessly."
            btnText="Book a Consultation"
          />
        </NewFooter>
      </main>
    </>
  );
}
